export const ART_EVENT_ENDPOINTS = {
  ART_EVENTS_ENDPOINT: '/api/v1/artEventID',
  DELETE_ART_EVENT_ENDPOINT: '/api/v1/artEventID',
};
